
import React from 'react';
import { CheckCircle } from 'lucide-react';

interface Service {
  title: string;
  description: string;
  features: string[];
  icon?: React.ElementType;
}

interface ServiceGridProps {
  title: string;
  subtitle: string;
  services: Service[];
}

const ServiceGrid = ({ title, subtitle, services }: ServiceGridProps) => {
  return (
    <section className="py-20 bg-navy-50/30">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-light text-navy-900 mb-6">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </h2>
            <p className="text-lg text-navy-600 font-light max-w-2xl mx-auto">
              {subtitle}
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                {service.icon && <service.icon className="text-blue-600 mb-4" size={32} />}
                <h3 className="text-xl font-semibold text-navy-900 mb-4">{service.title}</h3>
                <p className="text-navy-600 font-light mb-6 text-sm">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center gap-2 text-xs text-navy-600">
                      <CheckCircle size={10} className="text-blue-600 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceGrid;
